import { render, staticRenderFns } from "./apiDeleteProduct.vue?vue&type=template&id=781d28ba&scoped=true&"
import script from "./apiDeleteProduct.vue?vue&type=script&lang=js&"
export * from "./apiDeleteProduct.vue?vue&type=script&lang=js&"
import style0 from "./apiDeleteProduct.vue?vue&type=style&index=0&id=781d28ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781d28ba",
  null
  
)

export default component.exports